import { Injectable, signal } from '@angular/core';

export type ToastType = 'info' | 'success' | 'warning' | 'danger';

export interface Toast {
  id: number;
  type: ToastType;
  title: string;
  message?: string;
  duration: number;
}

const DEFAULT_DURATION = 4000;

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly toasts = signal<Toast[]>([]);
  private nextId = 1;

  /** Toasts actuellement affichés (du plus récent au plus ancien). */
  readonly items = this.toasts.asReadonly();

  show(type: ToastType, title: string, message?: string, duration = DEFAULT_DURATION): void {
    const toast: Toast = { id: this.nextId++, type, title, message, duration };
    this.toasts.update((list) => [toast, ...list]);

    if (duration > 0) {
      window.setTimeout(() => this.dismiss(toast.id), duration);
    }
  }

  success(title: string, message?: string): void {
    this.show('success', title, message);
  }

  error(title: string, message?: string): void {
    this.show('danger', title, message);
  }

  info(title: string, message?: string): void {
    this.show('info', title, message);
  }

  warning(title: string, message?: string): void {
    this.show('warning', title, message);
  }

  dismiss(id: number): void {
    this.toasts.update((list) => list.filter((toast) => toast.id !== id));
  }
}
